import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../Reducer/rootReducer';

export default createStore(
    rootReducer,
    applyMiddleware(thunk)
);


// WEBPACK FOOTER //
// ./src/ReduxRequests/Store/configureStore.ts